<template>
    <div class="login-form">
        <div class="login-form__title">Войти в Хёндэ Аукционы</div>

        <form class="login-form__fields" @submit.prevent="onSubmit">
            <UIInput
                id="email"
                v-model="form.email"
                placeholder="Email"
                :error-message="errors.email"
            />

            <UIPasswordInput
                id="password"
                v-model="form.password"
                placeholder="Пароль"
                :error-message="errors.password"
            />

            <a
                class="login-form__forgot"
                href="https://id.hyundai.ru/auth/forgotten"
                target="_blank"
            >Забыли пароль?</a>

            <div class="login-form__buttons">
                <UISimpleButton type="submit" :loading="loginLoading">Войти</UISimpleButton>

                <UISimpleButton
                    button-type="outlined"
                    @clicked="goToRegisterPage"
                >
                    Зарегистрироваться
                </UISimpleButton>
            </div>
        </form>
    </div>
</template>

<script lang="ts" setup>
    import { ref } from 'vue';
    import { useRouter, useRoute } from 'vue-router';

    import { injectStrict } from '@/injection/injectStrict';
    import { AuthKey } from '@/injection/keys';

    import UIInput from '@/components/ui/UIInput/UIInput.vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';
    import UIPasswordInput from '@/components/ui/UIPasswordInput/UIPasswordInput.vue';

    const $Auth = injectStrict(AuthKey);

    const router = useRouter();
    const route = useRoute();

    const form = ref({
        email: '',
        password: '',
        remember_me: false,
    });
    const errors = ref<Record<string, string>>({});
    const loginLoading = ref<boolean>(false);

    async function onSubmit(): Promise<void> {
        loginLoading.value = true;

        clearErrors();
        validateForm();

        if (Object.keys(errors.value).length > 0) {
            loginLoading.value = false;

            return;
        }

        try {
            await $Auth.loginUser(form.value);

            const redirect: string = route.query?.redirect as string;

            if (redirect) {
                router.push({ path: redirect });
            }
            else {
                router.push({ name: 'AuctionsList' });
            }
        }
        catch (error) {
            console.error('Ошибка авторизации:', error);
            handleErrors(error);
        }

        loginLoading.value = false;
    }

    function goToRegisterPage(): void {
        router.push({ name: 'Register' });
    }

    function validateForm(): void {
        if (!form.value.email) {
            errors.value.email = 'Пожалуйста, введите email';
        }
        else if (!isValidEmail(form.value.email)) {
            errors.value.email = 'Пожалуйста, введите корректный email';
        }

        if (!form.value.password) {
            errors.value.password = 'Пожалуйста, введите пароль';
        }
        // else if (form.value.password.length < 8) {
        //     errors.value.password = 'Пароль должен содержать не менее 8 символов';
        // }
    }

    function clearErrors(): void {
        errors.value = {};
    }

    function isValidEmail(email: string): boolean {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        return emailPattern.test(email);
    }

    function handleErrors(error: any): void {
        if (error.response && error.response.data) {
            const errorData = error.response.data;
            for (const key in errorData) {
                if (Object.hasOwnProperty.call(errorData, key)) {
                    errors.value[key] = errorData[key];
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use './LoginForm.scss' as *;
</style>
